module.exports = __webpack_public_path__ + "static/Service-hero-2-88f674b6838dd5d08dae840cd8b3958b.jpg";